import qs from 'querystring';

export const bannerEngagementAdapter = queryString => (
    qs.parse(queryString).banner ? `banner=${qs.parse(queryString).banner}` : ''
);
